// Pre-Approval milestones — the Pre-Approval tab. Five sections, the
// workflow ones owned by the Loan Administrator (B1):
//   1. Applications        (Borrower + Seller, attest Generated/Sent/Received)
//   2. Conditional Approval Letters (Borrower + Seller, attest Generated/Sent/ReceivedSigned)
//   3. Endorsement Records (the deal's approval-chain endorsements)
//   4. Document Requests   (requests spawned from the DocumentTypeRef catalog)
//   5. Final Approval to Underwriting (metrics + 3 attestations + Send action)
//
// Applications are produced through the existing report generator; the
// Conditional Approval letters are generated and signed in External
// Collection, whose approval chain also fills their blank milestones;
// document storage flows through the existing Document Repository. The page
// is purely the LA's attestation surface.

import { Card } from "@/design-system/components/ui";
import { useDocumentRequests } from "@/hooks/deals/useDealDetail";
import { DocumentRequestsSection } from "./DocumentRequestsSection";
import { PreApprovalApplicationsSection } from "./preapproval/PreApprovalApplicationsSection";
import { PreApprovalLettersSection } from "./preapproval/PreApprovalLettersSection";
import { PreApprovalFinalSubmissionSection } from "./preapproval/PreApprovalFinalSubmissionSection";
import { EndorsementRecordsSection } from "@/components/Collection/ApprovalChain/EndorsementRecordsSection";
import type { DealDetailDto } from "@/types/deals";

interface Props {
  deal: DealDetailDto;
}

export function DealPreApprovalTab({ deal }: Props) {
  const requestsQuery = useDocumentRequests(deal.id);

  if (deal.stage === "Intake") {
    return (
      <Card>
        <p className="text-small text-gray-mid italic m-0">
          Pre-Approval activity becomes available once the deal advances out of
          Intake.
        </p>
      </Card>
    );
  }

  return (
    <div className="flex flex-col gap-space-4">
      <PreApprovalApplicationsSection dealId={deal.id} />
      <PreApprovalLettersSection dealId={deal.id} />
      <EndorsementRecordsSection ownerEntityType="Deal" ownerEntityId={deal.id} />
      <DocumentRequestsSection deal={deal} requests={requestsQuery.data ?? []} />
      <PreApprovalFinalSubmissionSection dealId={deal.id} />
    </div>
  );
}
